uniform float uBass;
uniform float uActive;
uniform vec3  uColorA;
uniform vec3  uColorB;

varying float vRandom;
varying float vElevation;

void main() {
    float dist     = distance(gl_PointCoord, vec2(0.5));
    float strength = 1.0 - (dist * 2.0);          // 1 at centre → 0 at edge
    strength = pow(max(strength, 0.0), 6.0);       // sharp bright core, transparent edges
    strength *= uActive;

    float t   = vElevation * 0.5 + 0.5;
    vec3  col = mix(uColorA, uColorB, t);
    col += uBass * 0.4 * vec3(1.0, 0.7, 0.3);     // warm bass flash
    col  = clamp(col, 0.0, 1.0);

    gl_FragColor = vec4(col, strength);
}
